<template>
  <div>
    <div class="personnel1"></div>
    <div class="personnel2">
      <el-row :gutter="5">
        <el-form ref="elForm" size="medium" label-width="100px" label-position="left">
          <el-col :span="5">
            <el-form-item label-width="20px" label="" prop="field101">
              <el-input v-model="query.name_or_phone" placeholder="请输入社工名称或手机号" clearable :style="{width: '90%'}"
                @keyup.enter.native="search">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="JudgeButton(role_permission,'volunteer/query')">
            <el-form-item label-width="10px" label="" prop="field102">
              <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="2">
                <el-form-item label-width="1px" label="" prop="field103">
                  <el-button type="success" @click="$refs.add.show('')" icon="el-icon-circle-plus"> 新增 </el-button>
                </el-form-item>
              </el-col> -->
          <el-col :span="2" v-if="JudgeButton(role_permission,'volunteer/delete')">
            <el-form-item label-width="1px" label="" prop="field104">
              <el-button type="danger" :disabled="!multipleSelection.length" @click="delAll" icon="el-icon-milk-tea"> 删除
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="2" v-if="JudgeButton(role_permission,'volunteer/export')">
            <el-form-item label-width="1px" label="" prop="field104">
              <el-button :disabled="!list.length" type="warning" icon="el-icon-upload" @click="handleExport">导出
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>

    <div class="personnel3" v-loading='loading'>
      <el-table stripe border ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 95%"
        @selection-change="handleSelectionChange">
        <el-table-column align='center' type="selection" width="55">
        </el-table-column>
        <el-table-column align='center' prop='user_name' label="姓名"></el-table-column>
        <el-table-column align='center' label="性别" width="110">
          <template slot-scope="scope">
            {{ scope.row.user_sex | isSex }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop="user_phone" label="手机号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align='center' prop="add_time" label="创建(注册)时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align='center' prop="" label="身份" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.is_volunteer == 1">志愿者、</span>
            <span v-if="scope.row.user_role == 1">普通用户</span>
            <span v-if="scope.row.user_role == 2">社工</span>
          </template>
        </el-table-column>
        <el-table-column align='center' prop="user_area_name" label="区域" show-overflow-tooltip>
        </el-table-column>

        <el-table-column label="操作" align='center' width="500">

          <template slot-scope="scope">
            <!-- <el-button
                    size="mini"
                    type="primary"
                    @click="hanReset(scope.$index, scope.row)">服务记录</el-button>
                    <el-button
                    size="mini"
                    type="primary"
                    @click="customercick(scope.$index, scope.row)">服务对象</el-button> -->
            <el-button v-if="JudgeButton(role_permission,'volunteer/edit')" size="mini" type="primary"
              @click="$refs.add.show(scope.row)">编辑</el-button>
            <el-button v-if="JudgeButton(role_permission,'volunteer/query')" size="mini" type="primary"
               @click="$refs.detail.show(scope.row)">详情</el-button>
            <el-button v-if="JudgeButton(role_permission,'volunteer/record')" size="mini" type="primary"
              @click="$refs.sign.show(scope.row)">签到记录</el-button>
            <el-button v-if="JudgeButton(role_permission,'volunteer/notice')" size="mini" type="success"
              @click="noticecick(scope.$index, scope.row)">通知</el-button>

            <el-button v-if="JudgeButton(role_permission,'volunteer/edit') && scope.row.is_volunteer == 1 && scope.row.is_volunteer_recommend == 0" size="mini" type="success"
                @click="handleRecommend(scope.row, 1)">推荐</el-button>
            <el-button v-if="JudgeButton(role_permission,'volunteer/edit') && scope.row.is_volunteer == 1 && scope.row.is_volunteer_recommend == 1" size="mini" type="warning"
                @click="handleRecommend(scope.row, 0)">取消推荐</el-button>

            <el-button v-if="JudgeButton(role_permission,'volunteer/delete')" size="mini" type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page"
        :page-sizes="[10, 20, 50, 100]" :page-size="query.page_limit" layout="total, sizes, prev, pager, next, jumper"
        :total="query.total">
      </el-pagination>
    </div>

    <addUser ref='add' @success='getList'></addUser>
    <detailUser ref="detail"></detailUser>
    <signList ref="sign"></signList>
  </div>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import signList from "./components/signList.vue";
  import addUser from "./components/addUserDialog.vue";
  import detailUser from "./components/detailUserDialog.vue";
  export default {
    name: 'personnelManage',
    components: {
      signList,
      addUser,
      detailUser
    },
    props: {},
    data() {
      return {
        multipleSelection: [],
        list: [],
        query: {
          name_or_phone: '',
          page_limit: 10,
          page: 1,
          flag: '', // 操作标志 export=数据导出
          total: 0,
          user_type: 'volunteer'
        },
        loading: true
      }
    },
    computed: {
      role_permission() {
        return this.$store.getters.role_permission
      }
    },
    beforeDestroy() {
      this.$store.commit('CACHE_VOLUNTEER', this.query)
    },
    created() {
      if (this.$store.state.cache.cacheVolunteerQuery) this.query = this.$store.state.cache.cacheVolunteerQuery
      this.query.flag = ''
      this.getList()
    },
    methods: {
      search() {
        this.query.flag = '';
        this.query.page = 1;
        this.list = [];
        this.getList()
      },
      JudgeButton(list, rot) {
        let fal = false;
        list.forEach((i, l) => {
          if (i.path == rot) {
            return fal = true;
          }
        })
        return fal
      },
      handleExport() {
        this.query.flag = 'export';
        this.getList();
      },
      getList() {
        this.loading = true
        userInfoAPI.serviceUserList(this.query).then(res => {
          if (this.query.flag == 'export') {
            let blob = new Blob([res.data], {
              type: 'application/vnd.ms-excel'
            })
            let objectUrl = URL.createObjectURL(blob)
            let link = document.createElement('a')
            link.href = objectUrl
            link.setAttribute('download', '社工列表')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(objectUrl)
          } else {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      handleSizeChange(val) {
        this.query.flag = '';
        this.query.page_limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.query.flag = '';
        this.query.page = val;
        this.getList();
      },
      handleSelectionChange(val) { //是否全选框框
        this.multipleSelection = val;
      },
      delAll() {
        this.$confirm('此操作将永久删除选中人员, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceUserDel({
            user_id: this.multipleSelection.map(i => {
              return i.user_id
            }).join(',')
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
      },
      handleDelete(index, row) { //删除
        this.$confirm('此操作将永久删除该人员, 是否继续?', '删除提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.serviceUserDel({
            user_id: row.user_id
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      noticecick(index, row) { //通知
        userInfoAPI.serviceUserNotice({
          user_id: row.user_id
        }).then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: 'success',
              message: '通知成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      },
      handleRecommend(row, operate){
        this.$confirm('是否确定'+(operate==1?'推荐':'取消推荐')+'该人员?', '温馨提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          userInfoAPI.systemRecommend({
            data_id: row.user_id,
            data_type: 'volunteer',
            operate: operate // {0:取消推荐,1:标记推荐}
          }).then((res) => {
            if (res.data.code == 0) {
              this.getList()
              this.$message({
                type: 'success',
                message: res.data.msg
              })
            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })
      },
      customercick(index, row) { //服务对象
        console.log(index, row);
      }
    }
  }
</script>
<style lang='scss' scoped>
  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/ .el-dialog__header {
    background-color: rgb(62, 62, 238);
  }

  /deep/ .el-dialog__headerbtn {
    i {
      color: #fff;
    }
  }

  .personnel1 {
    height: 20px;
  }

  .personnel2 {}

  .personnel3 {
    margin-left: 20px;
  }
</style>
